/* PARALIA · carrito (cajón #PaCartDrawer y página /cart). Usa window.PA de paralia.js.
   - − / + / Quitar / cantidad: PA.change(línea, cantidad).
   - Regalo por monto: la sección marca en data-pa-cart-fix las líneas de regalo que sobran (total bajo la meta, repetidas
     o con cantidad > 1) y aquí se corrigen con PA.update({ updates }). Solo se tocan líneas con la propiedad _pa_regalo.
   - Selector del regalo: agrega la variante con properties: { _pa_regalo: '1' }; si ya estaba, cambia la línea.
   - Código de descuento: PA.update({ discount }) conservando los códigos que ya aplican; si no aplica, se quita y se avisa.
   - En /cart la sección de la página se vuelve a pedir después de cada cambio (data-pa-cart-page). */
(() => {
  if (window.PACart || !window.PA) return;
  const PA = window.PA;
  const GIFT_PROP = '_pa_regalo';
  let busy = false;
  let lastFix = '';
  let pendingFocus = null;
  let discountError = null;
  const keepOpen = new Set();

  const roots = () => document.querySelectorAll('[data-pa-cart-root]');
  const setBusy = on => roots().forEach(r => { r.classList.toggle('is-busy', on); r.setAttribute('aria-busy', on ? 'true' : 'false'); });

  /* ---------- después de cada render: estado de la interfaz ---------- */
  function restoreUI(fromPage = false) {
    document.querySelectorAll('[data-pa-cart-keep]').forEach(d => { if (keepOpen.has(d.getAttribute('data-pa-cart-keep'))) d.open = true; });
    document.querySelectorAll('[data-pa-cart-toggle]').forEach(b => {
      const id = b.getAttribute('data-pa-cart-toggle');
      if (keepOpen.has(id)) setPanel(b, true);
    });
    if (discountError) {
      document.querySelectorAll('[data-pa-cart-discount-error]').forEach(p => {
        p.textContent = discountError; p.hidden = false;
        const d = p.closest('details'); if (d) d.open = true;
      });
    }
    const live = document.querySelector('[data-pa-cart-live]');
    const msg = document.querySelector('[data-pa-cart-root] [data-pa-cart-msg]');
    if (live) live.textContent = msg ? msg.textContent.trim() : '';
    tryFocus(fromPage);
  }

  function tryFocus(fromPage = false) {
    if (!pendingFocus) return;
    const { key, mode } = pendingFocus;
    if (mode === 'page' && !fromPage) return; // la página se vuelve a pedir aparte
    const root = document.querySelector(`[data-pa-cart-root][data-mode="${mode}"]`);
    if (!root) return;
    const el = root.querySelector(`[data-pa-cart-focus="${CSS.escape(key)}"]`)
      || (mode === 'drawer' ? root.querySelector('[data-pa-cart-focus="drawer-close"]') : root.querySelector('h1'));
    if (el) { if (el.tagName === 'H1') el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); }
    pendingFocus = null;
  }

  async function refreshPage() {
    const page = document.querySelector('[data-pa-cart-page]');
    if (!page) return;
    const id = page.getAttribute('data-pa-section');
    try {
      const res = await fetch(`${PA.root}cart?sections=${encodeURIComponent(id)}`);
      PA.renderSections(await res.json());
    } catch (e) { /* si falla, la página queda como estaba; el cajón ya tiene lo nuevo */ }
    restoreUI(true);
  }

  /* ---------- una operación a la vez ---------- */
  async function run(fn, origin) {
    if (busy) return;
    busy = true;
    discountError = null;
    if (origin) {
      const f = origin.closest('[data-pa-cart-focus]') || origin;
      const root = origin.closest('[data-pa-cart-root]');
      if (f.dataset.paCartFocus && root) pendingFocus = { key: f.dataset.paCartFocus, mode: root.dataset.mode };
    }
    setBusy(true);
    try { await fn(); } catch (e) { showError(e && e.message); } finally {
      busy = false;
      setBusy(false);
      restoreUI();
      checkFix();
    }
  }

  function showError(message) {
    if (!message) return;
    document.querySelectorAll('[data-pa-cart-error]').forEach(p => { p.textContent = message; p.hidden = false; });
  }

  /* ---------- regalo: quitar lo que ya no toca ---------- */
  function checkFix() {
    if (busy) return;
    const el = document.querySelector('[data-pa-cart-root][data-pa-cart-fix]');
    const raw = el ? el.getAttribute('data-pa-cart-fix') : '';
    if (!raw || raw === '{}') { lastFix = ''; return; }
    if (raw === lastFix) return; // ya se intentó con este mismo carrito
    lastFix = raw;
    let updates;
    try { updates = JSON.parse(raw); } catch (e) { return; }
    run(() => PA.update({ updates }));
  }

  /* ---------- selector de variante (regalo y Combínalo con) ---------- */
  function pickerState(picker) {
    let variants = [];
    try { variants = JSON.parse(picker.querySelector('[data-pa-cart-variants]').textContent); } catch (e) { /* sin variantes */ }
    const chosen = {};
    picker.querySelectorAll('.pa-cart-pick__input:checked').forEach(i => { chosen[i.dataset.position] = i.value; });
    const variant = variants.find(v => v.options.every((o, idx) => chosen[idx + 1] === undefined || chosen[idx + 1] === o));
    return { variants, variant };
  }

  function onPickerChange(input) {
    const picker = input.closest('[data-pa-cart-picker]');
    const { variant } = pickerState(picker);
    const row = input.closest('.pa-cart-pick__row');
    const label = row && row.querySelector('[data-pa-cart-pick-label]');
    if (label) label.textContent = input.value;
    const add = picker.querySelector('[data-pa-cart-pick-add]');
    if (add) add.disabled = !variant || !variant.available;
    const scope = picker.closest('[data-pa-cart-gift]');
    const img = scope && scope.querySelector('[data-pa-cart-pick-img] img');
    if (img && variant && variant.image) { img.removeAttribute('srcset'); img.src = variant.image; }
    if (!variant) return;
    picker.dataset.variant = variant.id;

    const key = picker.dataset.key;
    if (picker.dataset.paCartPicker === 'gift' && key) {
      if (!variant.available || String(variant.id) === picker.dataset.current) return;
      run(async () => {
        await PA.update({ updates: { [key]: 0 } });
        await PA.add({ id: variant.id, quantity: 1, properties: { [GIFT_PROP]: '1' } }, { open: false });
      }, input);
    }
  }

  function setPanel(btn, open) {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------- código de descuento ---------- */
  const applicable = cart => (cart.discount_codes || []).filter(d => d.applicable).map(d => d.code);

  function applyDiscount(form) {
    const input = form.querySelector('input[name="discount"]');
    const code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    const errorText = form.dataset.error;
    run(async () => {
      const before = await PA.getCart();
      const keep = applicable(before);
      if (keep.some(c => c.toLowerCase() === code.toLowerCase())) return;
      let cart = await PA.update({ discount: [...keep, code].join(',') });
      if (!cart.discount_codes) cart = await PA.getCart();
      const hit = (cart.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      if (!hit || !hit.applicable) {
        await PA.update({ discount: keep.join(',') });
        discountError = errorText;
      }
    }, form.querySelector('[type="submit"]'));
  }

  function removeDiscount(btn) {
    const code = btn.getAttribute('data-pa-cart-code-remove');
    run(async () => {
      const cart = await PA.getCart();
      const rest = (cart.discount_codes || []).map(d => d.code).filter(c => c.toLowerCase() !== code.toLowerCase());
      await PA.update({ discount: rest.join(',') });
    });
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', e => {
    const change = e.target.closest('[data-pa-cart-change]');
    if (change) {
      e.preventDefault();
      run(() => PA.change(Number(change.dataset.line), Math.max(0, Number(change.dataset.qty))), change);
      return;
    }
    const toggle = e.target.closest('[data-pa-cart-toggle]');
    if (toggle) {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      setPanel(toggle, open);
      const id = toggle.getAttribute('data-pa-cart-toggle');
      if (open) keepOpen.add(id); else keepOpen.delete(id);
      return;
    }
    const quick = e.target.closest('[data-pa-cart-quick-add]');
    if (quick) {
      run(() => PA.add({ id: Number(quick.dataset.paCartQuickAdd), quantity: 1 }, { open: false }), quick);
      return;
    }
    const add = e.target.closest('[data-pa-cart-pick-add]');
    if (add) {
      const picker = add.closest('[data-pa-cart-picker]');
      const { variant } = pickerState(picker);
      if (!variant || !variant.available) return;
      const item = { id: variant.id, quantity: 1 };
      if (picker.dataset.paCartPicker === 'gift') item.properties = { [GIFT_PROP]: '1' };
      run(() => PA.add(item, { open: false }), add);
      return;
    }
    const removeCode = e.target.closest('[data-pa-cart-code-remove]');
    if (removeCode) { removeDiscount(removeCode); }
  });

  document.addEventListener('change', e => {
    const qty = e.target.closest('[data-pa-cart-qty]');
    if (qty) {
      const n = Math.max(0, parseInt(qty.value, 10) || 0);
      run(() => PA.change(Number(qty.dataset.line), n), qty);
      return;
    }
    if (e.target.matches('[data-pa-cart-picker] .pa-cart-pick__input')) onPickerChange(e.target);
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Enter' && e.target.matches('[data-pa-cart-qty]')) { e.preventDefault(); e.target.blur(); }
  });

  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-pa-cart-discount]');
    if (!form) return;
    e.preventDefault();
    applyDiscount(form);
  });

  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!d.matches || !d.matches('[data-pa-cart-keep]')) return;
    const id = d.getAttribute('data-pa-cart-keep');
    if (d.open) keepOpen.add(id); else keepOpen.delete(id);
  }, true);

  document.addEventListener('pa:cart:updated', () => {
    restoreUI();
    refreshPage();
    checkFix();
  });
  document.addEventListener('pa:cart:error', e => showError(e.detail && e.detail.message));

  /* Volver con el botón «atrás» (bfcache): el carrito pudo cambiar en otra pestaña. */
  window.addEventListener('pageshow', e => { if (e.persisted) PA.refresh().catch(() => {}); });

  const init = () => { restoreUI(); checkFix(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.PACart = { checkFix, refreshPage };
})();
